/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {Button, ButtonText} from '#/components/Button'
import {BodyText, Heading} from '#/wsocial/components/primitives'
import {IllustrationScanSuccessful} from './illustrations'
import {IllustrationArea, PageShell, SupportFooter} from './primitives'

export function StepVerifying({
  onSkip,
  allowSkip = true,
}: {
  onSkip: () => void
  allowSkip?: boolean
}) {
  return (
    <PageShell>
      <IllustrationArea>
        <IllustrationScanSuccessful />
      </IllustrationArea>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>
          Open W Identity on your phone and complete the verification
        </Heading>
        <BodyText>You will automatically continue once done.</BodyText>
      </div>

      {allowSkip && (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            justifyContent: 'center',
          }}>
          <Button
            label="Explore W without verifying"
            color="secondary"
            size="large"
            testID="skipBtn"
            onPress={onSkip}>
            <ButtonText>Explore W without verifying</ButtonText>
          </Button>
        </div>
      )}
      <SupportFooter />
    </PageShell>
  )
}
